import { Component, ComponentFactoryResolver, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NicaMaster } from '../../../components/nica-master-component/nica-master.component';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ComponentService } from '../../../services/component.service';
import { FormsTemplateService } from '../../../services/forms-template.service';
import { OverlaySideFormService } from '../../../components/shared/overlay-side-form/overlay-side-form.service';
import { NicaMenuService } from '../../../services/nica-menu.service';
import { RentriService } from '../../../services/rentri.service';
import { AnagraficaService } from '../../../services/anagrafica.service';
import { HttpClient } from '@angular/common/http';
import { Apiservice } from '../../../services/api.service';
import { NicaDataGridComponent } from '../../../components/nica-data-grid/nica-data-grid.component';
import { alert } from 'devextreme/ui/dialog';
import { format } from 'util';
import { formatNumber } from '@angular/common';
import { createGridConfig, gridDetail, gridSimple } from '../../../services/templates/gridSettings/gridSettings';

const clonneCausale = [
  {
    dataField: 'idOperazione',
    dataType: '',
    caption: 'Operazione',
    allowEditing: false,
    groupIndex: 0,
    colSpan: 2,
    lista: {

      dataSource: 'OperazioneCausaleRIfiuti',
      valueExpr: 'id',
      displayExpr: 'descrizione',


    },
  },


  {
    dataField: 'descrizione',
    dataType: '',
    caption: 'Descrizione',
    colWidth: '500',
    hideOnEdit: false
  },



]

const settingGridGenericMultiple = {
  masterKey: 'id',
  keyUnique: 'id',
  mode: null,
  selectionMode: 'multiple',
  remoteOperations: true,
  showFilterSearch: false,
  allowUpdating: false,
  allowDeleting: false,
  allowAdding: false,
  searchAndSelect: true, //Cerca Valore e seleziona
  height: 630,
  width: 800,
  showColBlank: false,
  colonne: [
    {
      dataField: 'id',
      dataType: '',
      caption: 'Codice',
      allowEditing: true,
      colWidth: '70'
    },
    {
      dataField: 'descrizione',
      dataType: '',
      caption: 'Descrizione',
      allowEditing: true,
      colWidth: '700'
    },
  ],

}

export interface Lavorazioni {

  id: number;
  idSchedaRifiuto: number;
  eer: string;
  riferimentoEER: string;
  idStatoFisico: string;
  idCausaleRifiuto: number;
  causaleRifiuto_Descizione: string;
  operazioneRD: any[];
  idMagazzinoRifiuto: number;
  magazzinoRifiuto_Descizione: string;
  percentuale: number,
  quantitaLavorata: number,
  idSchedaRifiutoRow: number

}[]

@Component({
  selector: 'app-gestione-lavorazioni-rifiuti',
  templateUrl: './gestione-lavorazioni-rifiuti.component.html',
  styleUrls: ['./gestione-lavorazioni-rifiuti.component.css']
})
export class GestioneLavorazioniRifiutiComponent extends NicaMaster implements OnInit {
  @ViewChild('dataGrid', { static: false }) nicaDataGrid: NicaDataGridComponent

  @Input() itemData: any;
  @Output() outputEmit: EventEmitter<any> = new EventEmitter<any>(); //Emit all'esterno
  @Output() emittendSelectionRow: EventEmitter<any> = new EventEmitter<any>(); //Emit all'esterno
  showGrid: boolean = false;
  dataSourceLavorazioni: any = [];
  colonneGriglialavorazione
  toolbarButtonsTop=[]
  constructor(
    private activateRoute: ActivatedRoute,
    public spinner: NgxSpinnerService,

    public apiservice: Apiservice,


    public userComponentService: ComponentService,
    public templateService: FormsTemplateService,
    public _overlaySideFormService: OverlaySideFormService,
    public _overlaySidePanelService: OverlaySideFormService,
    public formTemplateService: FormsTemplateService,
    public _componentFactoryResolver: ComponentFactoryResolver,
    public activatedroute: ActivatedRoute,
    public router: Router,
    public menuService: NicaMenuService,
    public rentriService: RentriService,
    public anagraficaService: AnagraficaService,
    public http: HttpClient,


  ) {
    super(
      userComponentService,
      templateService,
      _overlaySideFormService,
      _overlaySidePanelService,
      formTemplateService,
      _componentFactoryResolver,
      activatedroute,
      router,
      menuService,
      rentriService,
      anagraficaService,

    );

  }



  ngOnInit() {

    this.showToolBar = false;

    if (this.itemData) {
      this.setGlobalVariableFromParams(this.itemData[0])
      this.titleDynamic = this.itemData[0].title;
      let formData = this.itemData[0].data
      this.rowData['idSede'] = formData.idLotto_Sede;
      this.rowData['idPosizioneRifiuto'] = formData.idPosizioneRifiuto;

      console.log('itemData-->', this.rowData)

    } else {
      this.activatedroute.queryParams
        .subscribe(params => {

          this.currentTabId = params.currentTabId,
            this.currentTabName = params.currentTabName

          this.setGlobalVariableFromParams(params);
          // this.loader.hide()

        });
    }

    this.setViewLavorazioni()

  }

  async setViewLavorazioni() {

    let formData = this.filterID;



    this.colonneGriglialavorazione = [
      {
        itemType: "group", colSpan: '8', caption: "",
        groupDataField: 'datiLavorazione',

        data: [

          /**Dati Rifiuto */

          {
            type: 'campoSpecial',
            colVisible: true,
            allowEditing: true,
            dataField: "eer",
            colWidth: '110',
            orderGriglia: 7,
            width: '4.688vw',
            maxLength: '6',
            caption: "EER",
            disableOnUpdate: false,
            showClearButton:false,
            dynamic: {
              valueExpr: 'id',
              queryString: '',
              filterStatic: "?$filter=(not endswith(id,'00'))",
              displayExpr: '',
              dataSource: 'cer',
              service: 'cer',
              autocomplete: false,
              caption: "Lista EER",
              componentType: 'NicaDataGridComponent',
              buttonOption: {
                text: 'Codici CER',
                icon: 'glyphicon mdi mdi-playlist-plus',
                hint: 'Sfoglia Lista codici CER',
                name: 'CodiciCERLista',
                location: 'after',
              },
              settingGrid: gridSimple


            },
            validation: [
              { type: 'required', message: 'EER campo obbligatorio' }
            ]
          },

          {
            type: 'campo', dataField: "riferimentoEER", dataType: "",
            caption: "Rif.EER",
            colWidth: '100',
            width: '100',
            colVisible: true,
            labelVisible: true,
            maxLength: '10',
            orderGriglia: 8,
            allowEditing: true,
          },

          {
            type: 'campoSpecial', dataField: "idStatoFisico", dataType: "", caption: "SF",
            colWidth: '50',
            colVisible: true,
            labelVisible: true,
            orderGriglia: 9,
            class: 'stato-fisico',
            showClearButton: false,
            maxLength: '1',
            allowEditing: true,
            dynamic: {
              valueExpr: 'id',
              queryString: '',
              displayExpr: '',
              dataSource: 'StatoFisico',
              service: 'generic',
              autocomplete: false,
              caption: "Lista Stati Fisici",
              componentType:'dynamicGrid',
              buttonOption: {
                text: 'Lista Stati Fisici',
                icon: 'glyphicon mdi mdi-playlist-plus',
                hint: 'Sfoglia Lista Stati Fisici',
                name: 'StatoFisico',
                location: 'after',
              },
              settingGrid: gridSimple
            },
            validation: [
              { type: 'required', message: 'Stato fisico obbligatorio' }
            ]
          },

          {
            type: 'campoSpecial', dataField: "causaleRifiuto_Descizione", dataType: "", caption: "Causale rifiuti",

            colVisible: true,
            labelVisible: true,
            orderGriglia: 9,
            disableOnUpdate: true,
            allowEditing: true,
            colWidth: '200',
            showClearButton:false,
            dynamic: {
              valueExpr: '',
              queryString: "?IdPosizioneRifiuto=$idPosizioneRifiuto&$filter=((idOperazione eq 'A1' or idOperazione eq 'A2') and prodottoDaGestione eq 'S')",
              displayExpr: 'descrizione',
              service:'',
              dataSource: 'CausaleRifiuti/GetCausaliRifiutiByPosizione',
              autocomplete: false,
              componentType: 'NicaDataGridComponent',
              caption:'Causali con Prodotto da gestione',
              related: ['id|idCausaleRifiuto'],
              buttonOption: {
                text: 'StatoFisico',
                icon: 'glyphicon mdi mdi-playlist-plus',
                hint: 'Lista StatoFisico',
                name: 'StatoFisico',
                location: 'after',
              },
              settingGrid: createGridConfig(
                {
                  ...gridSimple,
                  colonne: clonneCausale
    
                }
    
              )
    
            },
            validation: [
              { type: 'required', message: 'Causale obbligatoria' }
            ]
          },
          {
            type: 'campoSpecial',
            dataField: "operazioneRD",
            dataType: "",
            caption: "Op.",
            colVisible: true,
            labelVisible: true,
            colWidth: '70',
            width: '8vw',
            disableOnUpdate: true,
            showInColumnChooser: false,
            allowEditing: true,
            showClearButton:false,

            dynamic: {

              dataSource: 'OperazioneSmaltimento',
              service: 'generic',
              autocomplete: false,
              valueExpr: '',
              displayExpr: 'id',
              caption: "Lista Operazioni Smaltimento e Recupero",
              queryString: '',
              filter: '',
              componentType: 'NicaDataGridComponent',
              //related: ['id|operazioneRD'],

              buttonOption: {
                text: 'Modalità di Stoccaggio',
                icon: 'glyphicon mdi mdi-playlist-plus',
                hint: 'Sfoglia Mod.Stoccaggio',
                name: 'stoccaggio',
                location: 'after',

              },
              settingGrid: gridSimple

            },
            validation: [
              { type: 'required', message: 'Operazione obbligatoria' }
            ]
          },

          {
            type: 'campoSpecial', dataField: "magazzinoRifiuto_Descizione", dataType: "", caption: "Magazzino",
            width: 17 + 'vw',

            colWidth: '200',
            colVisible: true,
            labelVisible: true,
            disableOnUpdate: false,
            allowEditing: true,
            showClearButton:false,
            dynamic: {
              dataSource: 'magazzinoRifiuti',
              service: '',
              valueExpr: '',
              displayExpr: 'descrizione',
              queryString: '?idSede=$idSede',
              caption: "Lista Magazzini",
              related: ['id|idMagazzinoRifiuto'],
              componentType: 'NicaDataGridComponent',
              buttonOption: {
                text: 'Modalità di Stoccaggio',
                icon: 'glyphicon mdi mdi-playlist-plus',
                hint: 'Sfoglia Mod.Stoccaggio',
                name: 'stoccaggio',
                location: 'after',

              },
              settingGrid: createGridConfig(
                {
                  ...gridSimple,
                  colonne:  [
        
                    {
                        dataField: 'descrizione',
                        dataType: '',
                        caption: 'Descrizione',
                        colWidth: 530,
                        allowEditing: true,
                    }, 
                ]
    
                }
    
              )
            },
            validation: [
              { type: 'required', message: 'Magazzino obbligatorio' }
            ]
          },


          {
            type: 'campo',
            dataField: "percentuale",
            format: "#,##0.00",
            dataType: "", editorType: 'dxNumberBox', caption: "Percentuale (%) ",
            width: '8vw',
            min: 0,
            max: 100,
            colWidth: '100',
            allowEditing: true,
          },
          {
            type: 'campo',
            dataField: "quantitaLavorata",
            format: "#,##0.00",
            editorType: 'number',
            caption: "Quantità",
            colWidth: '100',
            showEditor: true,
            showInSummary:true,
            validation: [
              { type: 'required', message: 'Quantita lavorata obbligatorio' }
            ]
          },

        ]
      },]

    const idSchedaLavorazione = formData['idSchedaDilavorazione'];
    const APISET = 'MovimentoRifiuti/GetListaSchedeLalorazione';

    let queryParams = '?';

    for (let x in this.filterID) {

      if (this.filterID.hasOwnProperty(x) && x != 'isEdit') {
        queryParams += x + '=' + this.filterID[x] + '&'
      }

    }

    this.anagraficaService.getElenco(APISET, '', queryParams).then(ress => {

      if (ress['items']) {
        ress = ress['items']

      }

      this.dataSourceLavorazioni = ress;
      this.showGrid = true;

    })
    const peso = formatNumber(Number(formData.QtaScaricata), 'it-IT', '1.0-3');
    let pesoMovimento = 'Totale Peso scaricato(Kg): ' + peso
    this.toolbarButtonsTop=[
      {
        id: 'textPeso',
        text: pesoMovimento,
        icon: null,
        disabled: false,
        image:null ,
        separator: null,
        visible: true,
        hint: '',
        name: 'peso',
        position:'left',
        widget: 'textDesc'
      }
    ]
   

  }

  gridEventLavorazione(event) {

    if (event.name == 'startingRowEditor') {
      console.log('startingRowEditor', event);
      let cells = event.cellsInfo
      let dataG = event.data
      for (let cell in cells) {
        if (cell != 'quantitaLavorata' && dataG.id != null) {
          cells[cell]['isEditable'] = false
        } else if (dataG.eer == null) {
          cells[cell]['isEditable'] = true
        }
      }


      //return event;
    }
  }

  rispostaBottoni(ev) {

    switch (ev) {
      case 16:
        let datatoSendOutput = {
          name: 'return'
        }
        this.outputEmit.emit(datatoSendOutput)
        break;
      case 15:

        this.convalidDataGrid()

        break;

    }
  }

  convalidDataGrid() {

    let checkValidation = true
    const editorData = this.nicaDataGrid.editorData;

    this.nicaDataGrid.saveEditorDataInbatch();

  
    /* editorData.forEach(editorDataR => {
      if (editorDataR.edit) {
        alert('Stai ancora modificando la lista delle lavorazioni', 'Attenzione');
        //this.nicaDataGrid.saveEditorData(editorDataR.rowIndex);
        checkValidation = false
        //return 
      }
    })
    if (!checkValidation) {
      return
    } */

    setTimeout(() => {
      const APISET = 'MovimentoRifiuti/ConvalidaListaSchedeLavorazioni?IdPosizioneRifiutoMovimentoDiScarico=' + this.rowData['idPosizioneRifiuto'];

      let rows = this.nicaDataGrid.righe.map(row => {
        return row.nativeElement
      })
  
      this.nicaDataGrid.rowSelected = [false];
      this.anagraficaService.actionPut(APISET, this.dataSourceLavorazioni, false).then(ress => {
        let messages = ''
        if (ress != '') {
          ress;
          for (let x in ress) {
            messages += '<p>' + ress[x].descrizione + '</p>';
            rows[ress[x].id].classList.add('error-row')
            this.nicaDataGrid.rowSelected[ress[x].id] = true;
          }
  
          alert(messages, 'Attenzione!')
  
        } else {
          let datatoSendOutputSave = {
            name: 'saveData',
            data: this.dataSourceLavorazioni
          }
  
          this.outputEmit.emit(datatoSendOutputSave)
          console.log('dataSourceLavorazioni-->', this.dataSourceLavorazioni)
        }
  
      })
    }, 500);
    
  }
}
